/* Custom problem-solution — tab switch. Click a tab → activate the
   matching panel via data-index. Keeps first tab open by default. */
(function () {
  if (customElements.get('problem-solution')) return;

  class ProblemSolution extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this._activate(parseInt(tab.dataset.tab, 10) || 0));
      });
    }

    _activate(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
    }
  }

  customElements.define('problem-solution', ProblemSolution);
})();
